import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getClinics = async () => {
  try {
    const response = await apiClient.get('/api/clinics');
    const clinics = response.data.clinics.map(clinic => ({
      ...clinic,
      rating: clinic.rating || Number((Math.random() * 2 + 3).toFixed(1)),
      tags: clinic.tags || ['Терапия','Узи','Хирургия'],
      logo: clinic.logo || '/logo.png',
      district: clinic.location?.district || 'Не указан',
      address: clinic.location?.address || 'Адрес не указан',
      placeId: clinic.location?.placeId || null,
      city: clinic.location?.city || 'Баку',
      schedule : "09:00-18:00"
    }));
    return { ...response.data, clinics };
  } catch (error) {
    console.error('Error fetching clinics:', error);
    throw error;
  }
};

export const getClinic = async (id) => {
  try {
    const response = await apiClient.get(`/api/clinics/${id}`);
    const clinic = {
      ...response.data.clinic,
      rating: response.data.clinic.rating || Number((Math.random() * 2 + 3).toFixed(1)),
      tags: response.data.clinic.tags || [],
      logo: response.data.clinic.logo || '/logo.png',
      district: response.data.clinic.location?.district || 'Не указан',
      address: response.data.clinic.location?.address || 'Адрес не указан',
      city: response.data.clinic.location?.city || 'Баку',
      contacts: response.data.clinic.contacts || { phones: ['+undef'] },
      website: response.data.clinic.website || 'https://eazy.pet/'
    };
    return { ...response.data, clinic };
  } catch (error) {
    console.error(`Error fetching clinic ${id}:`, error);
    throw error;
  }
};

export const getClinicServices = async (clinicId) => {
  try {
    const response = await apiClient.get(`/api/clinics/${clinicId}/services`);
    const services = response.data.services.map(service => ({
      ...service,
      price: service.price || 'Цена не указана',
      description: service.description || 'Описание отсутствует'
    }));
    return { ...response.data, services };
  } catch (error) {
    console.error(`Error fetching services for clinic ${clinicId}:`, error);
    throw error;
  }
};

export const getClinicSpecialists = async (clinicId) => {
  try {
    const response = await apiClient.get(`/api/clinics/${clinicId}/specialists`);
    const specialists = response.data.specialists.map(specialist => ({
      ...specialist,
      photo: specialist.photo || '/logo.png',
      avarage_rating: specialist.avarage_rating || (Math.random() * 2 + 3).toFixed(1),
      experience: specialist.experience || 'Не указан',
      specializations: specialist.specializations || [],
      description: specialist.description || 'Описание отсутствует'
    }));
    return { ...response.data, specialists };
  } catch (error) {
    console.error(`Error fetching specialists for clinic ${clinicId}:`, error);
    throw error;
  }
};

export async function getSpecialist(clinicId, specialistId) {
  try {
    const response = await apiClient.get(`/api/specialists/${specialistId}?clinic_id=${clinicId}`);
    const specialist = {
      ...response.data.specialist,
      photo: response.data.specialist.photo || '/logo.png',
      avarage_rating: response.data.specialist.avarage_rating || Number((Math.random() * 2 + 3).toFixed(1)),
      experience: response.data.specialist.experience || 'Не указан',
      specializations: response.data.specialist.specializations || [],
      description: response.data.specialist.description || 'Описание отсутствует'
    };
    return { ...response.data, specialist };
  } catch (error) {
    console.error('Error fetching specialist:', error);
    throw error;
  }
}

export async function getSpecialistSlots(specialistId, date) {
  try {
    const response = await apiClient.get(
      `/api/specialists/${specialistId}/slots?date=${date}`
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении слотов специалиста:', error);
    return { availableSlots: {} };
  }
}

export async function getSpecialistAllSlots(specialistId, days = 30) {
  try {
    const response = await apiClient.get(
      `/api/specialists/${specialistId}/slots?days=${days}`
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении слотов специалиста:', error);
    return { availableSlots: {} };
  }
}

export async function confirmBookingDetails({ clinic_id, service_id, spec_id, slot }) {
  try {
    const response = await apiClient.post('/api/bookings/confirm', {
      clinic_id,
      service_id,
      spec_id,
      slot
    });
    const bookingDetails = {
      ...response.data,
      clinic_name: response.data.clinic_name || 'Название клиники не указано',
      service_name: response.data.service_name || 'Название услуги не указано',
      specialist_name: response.data.specialist_name || 'Имя специалиста не указано',
      start_time: response.data.start_time || slot.start_time,
      end_time: response.data.end_time || slot.end_time
    };
    return bookingDetails;
  } catch (error) {
    console.error('Error confirming booking details:', error);
    throw error;
  }
}

export async function submitBooking({
  clinic_id,
  service_id,
  spec_id,
  start_time,
  end_time,
  name,
  phone,
  email,
  comment
}) {
  try {
    const response = await apiClient.post('/api/book', {
      clinic_id,
      service_id,
      spec_id,
      start_time,
      end_time,
      name,
      phone,
      email,
      comment
    });
    const confirmation = {
      ...response.data.confirmation,
      booking_id: response.data.confirmation?.booking_id || 'ID не присвоен',
      status: response.data.confirmation?.status || 'pending'
    };
    return { ...response.data, confirmation };
  } catch (error) {
    console.error('Error submitting booking:', error);
    throw error;
  }
}

export async function submitReview({
  booking_id,
  rating,
  review_text
}) {
  console.log(booking_id, rating, review_text);
  try {
    const response = await apiClient.post('/api/reviews', {
      booking_id,
      rating,
      review_text
    });
    return response.data;
  } catch (error) {
    console.error('Error submitting review:', error);
    throw error;
  }
}

export default apiClient; 